export default [
    {
        'code': '002',
        'name': 'กรุงเทพ (BANGKOK)',
        'image': require('@/assets/images/banking/bbl.svg'),
    },
    {
        'code': '006',
        'name': 'กรุงไทย (KRUNG THAI)',
        'image': require('@/assets/images/banking/ktb.svg'),
    },
    {
        'code': '025',
        'name': 'กรุงศรีอยุธยา (AYUDHAYA)',
        'image': require('@/assets/images/banking/bay.svg'),
    },
    {
        'code': '004',
        'name': 'กสิกรไทย (KASIKORN)',
        'image': require('@/assets/images/banking/kbank.svg'),
    },
    {
        'code': '069',
        'name': 'เกียรตินาคิน (KIATNAKIN)',
        'image': require('@/assets/images/banking/kk.svg'),
    },
    {
        'code': '028',
        'name': 'คาลิยง (CALYON)',
        'image': require('@/assets/images/banking/cacib.svg'),
    },
    {
        'code': '008',
        'name': 'เจพีมอร์แกน เชส (JPMORGAN CHASE)',
        'image': require('@/assets/images/banking/jpm.svg'),
    },
    {
        'code': '018',
        'name': 'ชูมิโตโม มิตซุย แบงกิ้ง คอร์ปอเรชั่น (SUMITOMO MITSUI BANKING CORPORATION)',
        'image': require('@/assets/images/banking/smbc.svg'),
    },
    {
        'code': '017',
        'name': 'ซิตี้แบงก์ (CITIBANK)',
        'image': require('@/assets/images/banking/citi.svg'),
    },
    {
        'code': '022',
        'name': 'ซีไอเอ็มบี ไทย (CIMB THAI)',
        'image': require('@/assets/images/banking/cimb.svg'),
    },
    {
        'code': '032',
        'name': 'ดอยซ์แบงก์ (DEUTSCHE BANK)',
        'image': require('@/assets/images/banking/db.svg'),
    },
    {
        'code': '005',
        'name': 'เดอะรอยัลแบงก์อ๊อฟสกอตแลนด์ เอ็น.วี. (THE ROYAL BANK OF SCOTLAND N.V.)',
        'image': require('@/assets/images/banking/rbs.svg'),
    },
    {
        'code': '010',
        'name': 'โตเกียว - มิตซูบิชิ ยูเอฟเจ (TOKYO-MITSUBISHI UFJ)',
        'image': require('@/assets/images/banking/mufg.svg'),
    },
    /*{
        'code': '011',
        'name': 'ทหารไทย (TMB)',
        'image': require('@/assets/images/banking/tmb.svg'),
    },*/
    {
        'code': '067',
        'name': 'ทิสโก้ (TISCO)',
        'image': require('@/assets/images/banking/tisco.svg'),
    },
    {
        'code': '071',
        'name': 'ไทยเครดิต เพื่อรายย่อย (THE THAI CREDIT RETAIL)',
        'image': require('@/assets/images/banking/tcrb.svg'),
    },
    {
        'code': '014',
        'name': 'ไทยพาณิชย์ (SIAM COMMERCIAL)',
        'image': require('@/assets/images/banking/scb.svg'),
    },
    {
        'code': '065',
        'name': 'ธนชาต (THANACHART)',
        'image': require('@/assets/images/banking/tbank.svg'),
    },
    {
        'code': '015',
        'name': 'นครหลวงไทย (THE SIAM CITY)',
        'image': require('@/assets/images/banking/non-banking.svg'),
    },
    {
        'code': '001',
        'name': 'ประเทศไทย (THAILAND)',
        'image': require('@/assets/images/banking/non-banking.svg'),
    },
    {
        'code': '034',
        'name': 'เพื่อการเกษตรและสหกรณ์การเกษตร (AGRICULTURE AND AGRICULTURAL COOPERATIVES)',
        'image': require('@/assets/images/banking/baac.svg'),
    },
    {
        'code': '039',
        'name': 'มิซูโฮ คอร์ปอเรต (MIZUHO CORPORATE)',
        'image': require('@/assets/images/banking/non-banking.svg'),
    },
    {
        'code': '026',
        'name': 'เมกะ สากลพาณิชย์ (MEGA INTERNATIONAL COMMERCIAL)',
        'image': require('@/assets/images/banking/mega.svg'),
    },
    {
        'code': '024',
        'name': 'ยูโอบี (UNITED OVERSEAS)',
        'image': require('@/assets/images/banking/uob.svg'),
    },
    {
        'code': '073',
        'name': 'แลนด์ แอนด์ เฮ้าส์ เพื่อรายย่อย (LAND AND HOUSES RETAIL)',
        'image': require('@/assets/images/banking/lhb.svg'),
    },
    {
        'code': '020',
        'name': 'สแตนดาร์ดชาร์เตอร์ด (ไทย) (STANDARD CHARTERED (THAI))',
        'image': require('@/assets/images/banking/sc.svg'),
    },
    {
        'code': '070',
        'name': 'สินเอเซีย (ACL)',
        'image': require('@/assets/images/banking/non-banking.svg'),
    },
    {
        'code': '027',
        'name': 'อเมริกาเนชั่นแนลแอสโซซิเอชั่น (AMERICA NATIONAL ASSOCIATION)',
        'image': require('@/assets/images/banking/boa.svg'),
    },
    {
        'code': '030',
        'name': 'ออมสิน (THE GOVERNMENT SAVINGS)',
        'image': require('@/assets/images/banking/gsb.svg'),
    },
    {
        'code': '033',
        'name': 'อาคารสงเคราะห์ (THE GOVERNMENT HOUSING)',
        'image': require('@/assets/images/banking/ghb.svg'),
    },
    {
        'code': '066',
        'name': 'อิสลามแห่งประเทศไทย (ISLAMIC OF THAILAND)',
        'image': require('@/assets/images/banking/ibank.svg'),
    },
    {
        'code': '031',
        'name': 'ฮ่องกงและเซี่ยงไฮ้แบงกิ้งคอร์ปอเรชั่น (THE HONGKONG AND SHANGHAI BANKING CORPORATION)',
        'image': require('@/assets/images/banking/hsbc.svg'),
    },
    {
        'code': '011',
        'name': 'ธนาคารทหารไทยธนชาต จำกัด (มหาชน) (TMBTHANACHAT BANK PUBLIC COMPANY LIMITED)',
        'image': require('@/assets/images/banking/tmb.svg'),
    }
]